import { getFirestore } from 'redux-firestore'
import { getFirebase } from 'react-redux-firebase'

export const addData = (data) => {
    return (dispatch, getState) => {
        const firestore = getFirebase().firestore();
        firestore.collection('responses').add({
            ...data,
            createdAt:new Date()
        }).then(() => {
            dispatch({ type: 'ADD_DATA', data});
        }).catch((err) => {
            dispatch({ type: 'ADD_DATA_ERROR', err});
        })
    }
}

export const storeBuyNowClick = () => {
    return (dispatch, getState) => {
        const firestore = getFirebase().firestore();
        firestore.collection('BuyNowClicks').add({
            buy_now_click:1,
            createdAt:new Date()
        }).then(() => {
            dispatch({ type: 'STORE_BUY_NOW_CLICK'});
        }).catch((err) => {
            dispatch({ type: 'STORE_BUY_NOW_CLICK_ERROR', err});
        })
    }
}

export const storeVideoClick = () => {
    return (dispatch, getState) => {
        const firestore = getFirebase().firestore();
        firestore.collection('VideoPlayCount').add({
            video_click:1,
            createdAt:new Date()
        }).then(() => {
            dispatch({ type: 'STORE_BUY_NOW_CLICK'});
        }).catch((err) => {
            dispatch({ type: 'STORE_BUY_NOW_CLICK_ERROR', err});
        })
    }
}